// @core/api/endpoints/attachment/list_attachments_by_ids.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAttachmentsByIDsRequest,
  ListAttachmentsResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get attachments by list of IDs
 * Retrieves multiple attachments by their IDs in a single request. Authorization is checked for each attachment individually; only authorized attachments are returned.
 */
export async function ListAttachmentsByIDs(
  data: ListAttachmentsByIDsRequest,
  options?: RequestOptions
): Promise<ListAttachmentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/by-ids`;
  const requestOptions = options;
  return client.post<ListAttachmentsResponse>(requestPath, data, requestOptions);
}
